import Container from '@/components/Container';
import PageLayout from '@/components/layout/page-layout';

import { FormEvent, useEffect, useMemo, useState } from 'react';
import { GiLoveLetter } from 'react-icons/gi';
import { motion } from 'framer-motion';
import { useRef } from 'react';
import { useRouter } from 'next/router';

export default function Page() {
	return (
		<PageLayout>
			<Container className="py-8">
				<h1 className="text-3xl font-bold">Boletim Informativo</h1>

				<div className="mt-4">
					<NewsletterSignUp />
				</div>
			</Container>
		</PageLayout>
	);
}

function validateEmail(email: string) {
	return /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
		email
	);
}

export function NewsletterSignUp() {
	const [email, setEmail] = useState('');
	const [isMounted, setIsMounted] = useState(false);
	const formRef = useRef<HTMLFormElement>(null);
	const [message, setMessage] = useState('');
	const [errorMessage, setErrorMessage] = useState('');
	const router = useRouter();
	async function subscribeToNewsletter(email: string) {
		console.log(process.env.NEXT_PUBLIC_WEB_DOMAIN);

		const response = await fetch(
			// https://api.deixevivo.org.br/api/v1
			'/api/v1/newsletter/subscribe',
			{
				method: 'POST',
				body: JSON.stringify({ email }),
			}
		);
		const content = await response.json();

		if (content) {
			setMessage(content.message);
			const timer = setTimeout(() => {
				clearTimeout(timer);
				router.reload();
			}, 2000);
		}

	}

	const handleFormSubmit = (event: FormEvent<HTMLFormElement>) => {
		event.preventDefault();
		event.stopPropagation();

		let data: { email: string } = { email: '' };

		let formData = new FormData(event.currentTarget);

		for (let [key, value] of formData.entries()) {
			data[key] = value;
		}

		if (validateEmail(data.email)) {
			if (message) setMessage('');

			console.log(data);

			subscribeToNewsletter(data.email);
		} else {
			setMessage(
				'Ops. Pelos nossos testes você está fornecendo um e-mail incorreto. Por gentileza, valide-o!'
			);
		}
	};

	useEffect(() => {});

	return (
		<Container>
			<div className="container mx-auto py-10 max-w-[60ch] px-2 ">
				<div className="text-center p-4">
					<motion.div
						className="flex justify-center mb-4"
						animate={{
							translateY: [-8, 0, 8, 0],
						}}
						transition={{
							repeat: Infinity,
							duration: 2,
							ease: 'linear',
							repeatType: 'mirror',
						}}
					>
						<GiLoveLetter className="fill-primary-dark" size={64} />
					</motion.div>

					<h2>Inscreva-se em nosso Boletim Informativo</h2>
					<p className="font-bold">
						e fique por dentro de todas as atividades do Instituto Deixe Vivo!
					</p>
				</div>

				<form
					id="newsletter-sign-up"
					className="w-full"
					ref={formRef}
					onSubmit={handleFormSubmit}
				>
					<label
						htmlFor="email"
						className="flex border-2 border-secondary-dark rounded-lg h-12"
					>
						<input
							type="email"
							name="email"
							placeholder="E-mail"
							className="mx-auto px-4 flex-1 bg-transparent text-black"
							required
						/>
						<button
							type="submit"
							className="ml-2 p-2 bg-secondary-dark font-bold uppercase"
							formTarget="newsletter-sign-up"
						>
							Enviar
						</button>
					</label>
				</form>

				<div className="text-center font-bold">
					{message && <p className="text-success">{message}</p>}
					{errorMessage && <p className="text-danger">{errorMessage}</p>}
				</div>
			</div>
		</Container>
	);
}
